export default __webpack_public_path__ + "static/media/gallery_pic.12cc3741.jpg";